export default "__VITE_ASSET__U09hdFSt__"